import type { SvgIconComponent } from '@mui/icons-material'
import { IconButton, Tooltip } from '@mui/material'
import React from 'react'
import { generatePath, useLocation } from 'react-router'
import { Link } from 'react-router-dom'

interface NavigationMenuItemProps {
  path: string
  title: string
  icon: SvgIconComponent
  iconSelected: SvgIconComponent
}

const NavigationMenuItem: React.FC<NavigationMenuItemProps> = ({ path, title, icon, iconSelected }) => {
  const generatedPath = generatePath(path)

  const { pathname } = useLocation()

  const isSelected = pathname === generatedPath || pathname.startsWith(generatedPath + '/')
  return (
    <Tooltip arrow title={title}>
      <IconButton component={Link} to={generatedPath}>
        {React.createElement(isSelected ? iconSelected : icon, {
          color: isSelected ? 'primary' : 'inherit',
          fontSize: 'medium',
        })}
      </IconButton>
    </Tooltip>
  )
}

export default NavigationMenuItem
